import { IWizardState } from '@opengov/component-library/dist';
import { createSelector } from '@opengov/compose-app/reselect';
import { LocaleText } from '../../../../src/locale';

import { selectMultiDatasetFlag } from '../../../common/flags';
import { reportLocaleText } from '../../../common/locale';
import { selectNewReport } from '../../selectors/selectReportCreateState';
import { reportCreateActionCreators } from '../../state/reportCreateState';
import { IRecordOf } from '@opengov/compose-app/immutable';
import { IReportResponse } from '@opengov/reporting-types';

export const getReportCreateTypeProps = (
  localeText: LocaleText,
  newReport: IRecordOf<IReportResponse>,
  multiDatasetEnabled: boolean
) => {
  return {
    reportLocaleText: localeText,
    multiDatasetEnabled,
    onBackButtonClick: (wizardComponentProps: IWizardState) => {
      // Reset number of steps since we bump it to 3 if a lens is selected
      if (newReport.lensId) wizardComponentProps.setNumberOfSteps(2);
      wizardComponentProps.decrementStep();
    },
    onSelectReportType: (type: string) => reportCreateActionCreators.updateReportType(type)
  };
};

export const selectReportCreateTypeProps = createSelector(
  reportLocaleText,
  selectNewReport,
  selectMultiDatasetFlag,
  getReportCreateTypeProps
);
